module.exports = __webpack_public_path__ + "static/AboutUS_minimized.178715b2.gif";